module.exports = __webpack_public_path__ + "images/tour/activity_record_observation-2696f46c0c86c555d03674e0e061a334.gif";